import { render } from "./ResourcesView.vue?vue&type=template&id=efd85458"
import script from "./ResourcesView.vue?vue&type=script&lang=js"
export * from "./ResourcesView.vue?vue&type=script&lang=js"

import "./ResourcesView.vue?vue&type=style&index=0&id=efd85458&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__